export const MESSAGE_TYPE_ENUM = {
  GET_BASE_APP_AUTH_INFO: 'GET_BASE_APP_AUTH_INFO',
  RES_GET_BASE_APP_AUTH_INFO: 'RES_GET_BASE_APP_AUTH_INFO',
  ROUTE_SYNC_TO_BASE_APP: 'ROUTE_SYNC_TO_BASE_APP',
  ROUTE_SYNC_TO_SUB_APP: 'ROUTE_SYNC_TO_SUB_APP',
  SUB_BASE__SET_TAG_TITLE: 'SUB_BASE__SET_TAG_TITLE', // fmt: direction__desc  direction__desc__res
  BASE_SUB__RELOAD_IFRAME: 'BASE_SUB__RELOAD_IFRAME',
  SUB_BASE__ADD_PAGE_TAG_AND_GO: 'SUB_BASE__ADD_PAGE_TAG_AND_GO',
  SUB_BASE__DOCUMENT_CLICK: 'SUB_BASE__DOCUMENT_CLICK',
  SUB_BASE__GO_LOGIN_PAGE: 'SUB_BASE__GO_LOGIN_PAGE',
  SUB_BASE__PARENT_OPEN: 'SUB_BASE__PARENT_OPEN',
  SUB_BASE__COMPOSE_ACTIONS: 'SUB_BASE__COMPOSE_ACTIONS',
}

export const COMPOSE_ACTIONS_TYPE_ENUM = {
  closeSelf: 'closeSelf',
  message: 'message',
  addTagAndGo: 'addTagAndGo',
  showParentTag: 'showParentTag',
  postMessageToParentTag: 'postMessageToParentTag',
  parentHistoryGo: 'parentHistoryGo',
}

export default MESSAGE_TYPE_ENUM
